import { useEffect, useState } from 'react';
import { apiGet } from '../api/client';
import Spinner from '../components/Spinner';

export default function Health() {
  const [status, setStatus] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>('');
  const envName = (import.meta as any)?.env?.VITE_ENV || 'dev';

  useEffect(() => {
    (async () => {
      setLoading(true);
      setError('');
      try {
        const res = await apiGet('/health');
        setStatus(`${res.status} ${res.statusText}`);
      } catch (e: any) {
        setError(e?.message || String(e));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <h2>REST API Health</h2>
      <div>Base: {import.meta.env.VITE_API_BASE}</div>
      {loading && <Spinner label="Loading..." />}
      {!loading && (error ? <div style={{ color: 'crimson' }}>Error: {error}</div> : <div>Status: {status}</div>)}
      {envName === 'dev' && (
        <p style={{ marginTop: 16, color: '#555' }}>
          Ensure VITE_API_KEY is set in .env.local if your API requires an API key.
        </p>
      )}
    </div>
  );
}
